/*global jQuery, subscribeToCalendars*/
( function ( $ )
{
    /// <summary>
    /// jQuery UI widget for managing a mini calendar section.
    /// </summary>
    $.widget("ui.GridCalendar",
    {
        options:
        {
            /// <summary>
            /// Callback function used to merge in extra post database to to SelectMonthUrl.
            /// Callback is to returned the merged data.
            /// function (aOriginalData)
            /// </summary>
            MergeExtraPostData: null,
            /// <summary>
            /// Url from which provides the big calendar view.
            /// </summary>
            SubscribeUrl: null,
            /// <summary>
            /// Url from which provides the big calendar view.
            /// </summary>
            GridUrl: null,
            /// <summary>
            /// Initially selected month.
            /// </summary>
            SelectedMonth: null,
            /// <summary>
            /// Html to display in the grid area while loading new events from the server.
            /// </summary>
            LoadingHTML: '<div class="fbcms_calendar_grid_loading">'
                + '<img src="/img/spacer.gif" alt="Loading Calendar Events..." title="Loading Events..."/>'
                + '<div>Loading Events...</div>'
                + '</div><!-- .fbcms_calendar_grid_loading //-->',
            /// <summary>
            /// Html to show in the grid area if an error occurred loading events from the server.
            /// </summary>
            ErrorHTML: '<div class="fbcms_calendar_grid_error">'
                + '<img src="/img/spacer.gif" alt="Error Loading Calendar Events." title="Error Loading Events."/>'
                + '<div>Error Loading Events.</div>'
                + '</div><!-- .fbcms_calendar_grid_error //-->'
        },

        /// <summary>
        /// jQuery UI widget destroy.
        /// </summary>
        _destroy: function ()
        {
            return undefined;
        },

        /// <summary>
        /// jQuery UI widget init.
        /// </summary>
        _init: function ()
        {
            return undefined;
        },

        /// <summary>
        /// jQuery UI widget create.
        /// </summary>
        _create: function ()
        {
            var self, jElement;

            self = this;
            jElement = $(self.element);

            jElement.on('click', '.ical_show_button',
                function (aEvent)
                {
                    aEvent.preventDefault();
                    subscribeToCalendars( self.options.SubscribeUrl );
                }
            );

            jElement.on('click', '.next_button',
                function (aEvent)
                {
                    aEvent.preventDefault();
                    self.ChangeMonth(null, 'Next');
                }
            );

            jElement.on('click', '.previous_button',
                function (aEvent)
                {
                    aEvent.preventDefault();
                    self.ChangeMonth(null, 'Previous');
                }
            );

            jElement.on( 'change', 'select[name=month]', function ( e )  //ignore jslint
            {
                self.ChangeMonth($(this).val());
            });

            self._setupTooltips();
        },

        ChangeMonth: function (aMonth, aButtonClicked, aMergeExtraPostData)
        {
            var self, jElement, lMyData;

            self = this;
            jElement = $(self.element);
            jElement.html(self.options.LoadingHTML);

            if ( aMonth !== undefined && aMonth !== null)
            {
                self.options.SelectedMonth = self.GetSelectedMonth(aMonth);
            }

            lMyData = {
                'Month': self.options.SelectedMonth,
                'ButtonClicked': (aButtonClicked === undefined) ? '' : aButtonClicked,
                'rndm': Math.random(),
                'HideNavigation': true
            };

            if (typeof aMergeExtraPostData === 'function')
            {
                lMyData = aMergeExtraPostData(lMyData);
            }
            else if (typeof self.options.MergeExtraPostData === 'function')
            {
                lMyData = self.options.MergeExtraPostData(lMyData);
            }

            $.ajax(self.options.GridUrl, {
                success: function (data, textStatus, jqXHR) //ignore jslint
                {
                    jElement.html(data);
                    self.options.SelectedMonth = jElement.find("input.selected_month").val();
                    self._setupTooltips();
                },
                error: function ( jqXHR, textStatus, errorThrown ) //ignore jslint
                {
                    jElement.html(self.options.ErrorHTML);
                },
                data: lMyData,
                type: 'POST'
            });
        },

        _setupTooltips: function ()
        {
            var self, jElement, lToggleEventRowFunc;

            self = this;
            jElement = $(self.element);
            
            $.each(
                jElement.find('.dayeventlink .event_row'),
                function ( aIndex, aValue ) //ignore jslint
                {
                    var lRow, lDetails;

                    lRow = $(aValue);
                    lDetails = lRow.find('.event_details .details');
                    if (lDetails.length !== 0)
                    {
                        lRow.addClass('event_details_closed');
                        lRow.attr('tabindex', "0");
                    }
                }
            );
            
             lToggleEventRowFunc = function(aContainerElement, aRowElement)
                {
                    var jEventDetails = aRowElement.find('.event_details');
                    if (jEventDetails.length !== 0)
                    {
                        if ( aRowElement.hasClass( 'event_details_closed' ) )
                        {
                            aContainerElement.find( '.event_details_open' ).removeClass( 'event_details_open' ).addClass( 'event_details_closed' );
                            aContainerElement.find( '.details' ).hide();
                            aRowElement.removeClass( 'event_details_closed' ).addClass( 'event_details_open' );
                            jEventDetails.find( '.details' ).show();
                        }
                        else if ( aRowElement.hasClass( 'event_details_open' ) )
                        {
                            aRowElement.removeClass( 'event_details_open' ).addClass( 'event_details_closed' );
                            jEventDetails.find( '.details' ).hide();
                        }
                    }
                };
            
            jElement.find('.event_item_link')
                        .vptooltip({
                            fetchContentElementCallback: function ( clickedObj )
                            {
                                return $(clickedObj).parent().find('.event_details').get(0);
                            }
                        });

            jElement.find('.dayeventlink')
                    .vptooltip({
                        fetchContentElementCallback: function ( clickedObj )
                        {
                            return $(clickedObj).find('.mini_day_calendar_wrapper').get(0);
                        },
                        bindHackCallback: function (jPopupDiv)
                        {
                            jPopupDiv.on('click', '.event_row', function ()
                            {
                                var jEventRow = $(this);
                                lToggleEventRowFunc(jPopupDiv, jEventRow);
                            })
                            .on('keypress', '.event_row', function ( event )
                            {
                                var keycode, jEventRow;

                                keycode = parseInt( event.keyCode || event.which, 10);
                                if ( keycode === 13 )
                                {
                                    jEventRow = $(this);
                                    lToggleEventRowFunc(jPopupDiv, jEventRow);
                                }
                            } );
                        }
                    });
        },

        /// <summary>
        /// Gets the position offset for an object.
        /// </summary>
        _getposOffset: function (what, offsettype)
        {
            var totaloffset, parentEl;

            totaloffset = (offsettype === "left") ? what.offsetLeft : what.offsetTop;
            parentEl = what.offsetParent;
            while (parentEl !== null)
            {
                totaloffset = (offsettype === "left") ? totaloffset + parentEl.offsetLeft : totaloffset + parentEl.offsetTop;
                parentEl = parentEl.offsetParent;
            }
            return totaloffset;
        },
        /// <summary>
        /// Returns the current selected month.
        /// </summary>
        GetSelectedMonth: function (aDateString)
        {
            var lSelectedMonth = "";
            if (aDateString === undefined || aDateString === null)
            {
                lSelectedMonth = this.options.SelectedMonth;
            }
            else
            {
                lSelectedMonth = aDateString;
            }
            return lSelectedMonth;
        }
    });
}(jQuery));
